<template>
	<div class="student-index">
		<headerTemplate title="供销中心"></headerTemplate>
		<Board></Board>

		<van-cell title="系统公告" is-link :to="{name:'SaleNotice'}">
			<van-icon color="#2f89fa" name="todo-list-o" size="22" slot="icon" style="margin-right:3px;" />
		</van-cell>
		<van-cell title="商品查询" is-link :to="{name:'SaleProduct'}">
			<van-icon color="#2f89fa" name="todo-list-o" size="22" slot="icon" style="margin-right:3px;" />
		</van-cell>
		<van-cell title="自动更新库存" is-link :to="{name:'SaleStock'}">
			<van-icon color="#2f89fa" name="todo-list-o" size="22" slot="icon" style="margin-right:3px;" />
		</van-cell>
		<van-cell title="订单查询" is-link :to="{name:'SaleOrder'}">
			<van-icon color="#2f89fa" name="todo-list-o" size="22" slot="icon" style="margin-right:3px;" />
		</van-cell>
		<van-cell title="售后订单" is-link :to="{name:'SaleAfter'}">
			<van-icon color="#2f89fa" name="todo-list-o" size="22" slot="icon" style="margin-right:3px;" />
		</van-cell>
		<van-cell title="货源管理" is-link :to="{name:'SaleSource'}">
			<van-icon color="#2f89fa" name="todo-list-o" size="22" slot="icon" style="margin-right:3px;" />
		</van-cell>
		<van-cell title="店铺管理" is-link :to="{name:'SaleShop'}">
			<van-icon color="#2f89fa" name="todo-list-o" size="22" slot="icon" style="margin-right:3px;" />
		</van-cell>
		<van-cell title="销售统计" is-link :to="{name:'SaleStatistic'}">
			<van-icon color="#2f89fa" name="todo-list-o" size="22" slot="icon" style="margin-right:3px;" />
		</van-cell>

		<!-- <div class="nav-wrapper">
			<index-info-item @onclick="openNotice" class="mt-5" iconfont="&#xe62d;" title="系统公告"></index-info-item>
			<index-info-item @onclick="openProduct" class="mt-5" iconfont="&#xe62d;" title="商品查询"></index-info-item>
			<index-info-item @onclick="openStock" class="mt-5" iconfont="&#xe62d;" title="自动更新库存"></index-info-item>
			<index-info-item @onclick="openOrder" class="mt-5" iconfont="&#xe62d;" title="订单查询"></index-info-item>
			<index-info-item @onclick="openAfter" class="mt-5" iconfont="&#xe62d;" title="售后订单"></index-info-item>
			<index-info-item @onclick="openSource" class="mt-5" iconfont="&#xe62d;" title="货源管理"></index-info-item>
			<index-info-item @onclick="openShop" class="mt-5" iconfont="&#xe62d;" title="店铺管理"></index-info-item>
			<index-info-item @onclick="openStatistic" class="mt-5" iconfont="&#xe62d;" title="销售统计"></index-info-item>
		</div> -->
	</div>
</template>

<script>
	import headerTemplate from '@/components/headerTemplate/headerTemplate'
	import Board from '@/components/sale/board/Board'
	export default {
		name: 'SaleIndex',
		components: {
			headerTemplate, Board
		},
		data() {
			return {
			}
		},
		methods: {}
	}
</script>

<style lang="scss" scoped>

</style>